import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import {
  InMemoryCache,
  IntrospectionFragmentMatcher,
} from 'apollo-cache-inmemory'
import { split } from 'apollo-link'
import { WebSocketLink } from 'apollo-link-ws'
import { getMainDefinition } from 'apollo-utilities'
import { GATEWAY_URI, GQL_CONNECTION_SECURE } from 'config'

const secure = GQL_CONNECTION_SECURE ? 's' : ''

// Store references to reconnect WebSocket when auth state changes
let currentClient = null
let currentWsLink = null

async function initializeClient() {
  // Fragment matcher
  const introspectionQueryResultData = await getSchemas()
  const fragmentMatcher = new IntrospectionFragmentMatcher({
    introspectionQueryResultData,
  })

  // Links
  const httpLink = new HttpLink({
    credentials: 'include',
    uri: `http${secure}://${GATEWAY_URI}`,
  })

  currentWsLink = createWebSocketLink()

  const link = split(
    // split based on operation type
    ({ query }) => {
      const { kind, operation } = getMainDefinition(query)
      return kind === 'OperationDefinition' && operation === 'subscription'
    },
    currentWsLink,
    httpLink
  )

  currentClient = new ApolloClient({
    cache: new InMemoryCache({
      fragmentMatcher,
    }),
    link,
  })

  return currentClient
}

function createWebSocketLink() {
  return new WebSocketLink({
    uri: `ws${secure}://${GATEWAY_URI}`,
    fetchOptions: {
      mode: 'no-cors',
    },
    options: {
      reconnect: true,
      // Include cookies in WebSocket connection
      connectionParams: () => {
        // Get cookies from document.cookie and parse them
        const cookies = document.cookie.split(';').reduce((acc, cookie) => {
          const [name, value] = cookie.trim().split('=')
          if (name && value) {
            acc[name] = decodeURIComponent(value)
          }
          return acc
        }, {})

        return {
          headers: {
            // Include any session cookies here
            cookie: document.cookie,
          },
          // You can also include specific auth tokens if available
          ...cookies,
        }
      },
    },
  })
}

// Function to reconnect WebSocket with new authentication
export function reconnectWebSocket() {
  if (!currentClient && !currentWsLink) return null

  console.log('Reconnecting WebSocket with updated authentication...')

  // Close existing WebSocket connection
  currentWsLink?.subscriptionClient?.close?.()

  initializeClient()

  return currentClient
}

async function getSchemas() {
  const result = await fetch(`http${secure}://${GATEWAY_URI}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({
      variables: {},
      query: `
        {
          __schema {
            types {
              kind
              name
              possibleTypes {
                name
              }
            }
          }
        }
      `,
    }),
  })
  if (result.status === 401) console.log('Fragment Matcher Error: unauthorized')
  const res = await result.json()
  const filteredData = res.data.__schema.types.filter(
    (type) => type.possibleTypes !== null
  )
  res.data.__schema.types = filteredData
  return res.data
}

export default initializeClient
